import React, { useMemo } from 'react';
import { Pressable, View } from 'react-native';
import { Link } from 'expo-router';
import { useTranslation } from 'react-i18next';
import { Text } from '@/components/gluestack/text';
import { HugeIconsWrapper } from '@/components/ui/HugeIconsWrapper';
import { ArrowRight01Icon, GiftIcon, Notebook02Icon } from '@hugeicons-pro/core-stroke-rounded';

/** Billing sub-pages linked from Plans (header menu, or the right panel on wide screens). */
export function useBillingLinks() {
  const { t } = useTranslation();
  return useMemo(
    () => [
      {
        href: '/account/transactions' as const,
        icon: Notebook02Icon,
        label: t('account.transactions.title'),
      },
      {
        href: '/account/gift-certificates' as const,
        icon: GiftIcon,
        label: t('account.certificates.title'),
      },
    ],
    [t]
  );
}

/** Bordered list of the billing sub-pages, for the Plans right panel. */
export function BillingLinksList() {
  const billingLinks = useBillingLinks();

  return (
    <View className="overflow-hidden rounded-xl border border-outline-100">
      {billingLinks.map((link, index) => (
        <Link key={link.href} href={link.href} asChild>
          <Pressable
            className={`flex-row items-center gap-3 px-4 py-3 web:hover:bg-background-50 ${index > 0 ? 'border-t border-outline-100' : ''}`}>
            <HugeIconsWrapper icon={link.icon} size={20} className="text-typography-700" />
            <Text className="flex-1 font-semibold text-typography-800">{link.label}</Text>
            <HugeIconsWrapper icon={ArrowRight01Icon} size={18} className="text-typography-500" />
          </Pressable>
        </Link>
      ))}
    </View>
  );
}
